import { defineMessages } from 'react-intl';

export default defineMessages({
  admins: {
    defaultMessage: 'Admins',
    id: 'src.HomePage.profile.admins.tabName',
  },
  allRides: {
    defaultMessage: 'Rides',
    id: 'src.HomePage.create.allRides.tabName',
  },
  companyInfo: {
    defaultMessage: 'Company Info',
    id: 'src.HomePage.profile.companyInfo.tabName',
  },
  current: {
    defaultMessage: 'Current',
    id: 'src.HomePage.create.current.tabName',
  },
  info: {
    defaultMessage: 'Info',
    id: 'src.HomePage.info',
  },
  past: {
    defaultMessage: 'Past',
    id: 'src.HomePage.create.allRides.past.tabName',
  },
  riders: {
    defaultMessage: 'Riders',
    id: 'src.HomePage.profile.riders.tabName',
  },
  upcoming: {
    defaultMessage: 'Upcoming',
    id: 'src.HomePage.create.upcoming.tabName',
  },
  users: {
    defaultMessage: 'Users',
    id: 'src.HomePage.users',
  },
  userTotal: {
    defaultMessage: 'Users ({numUsers})',
    id: 'src.HomePage.userTotal',
  },
});
